import Button from "../core/Button";
import ResizableScene from "../core/ResizableScene";
import ScaleManager from "../core/ScaleManager";
import PlayerData from "../PlayerData";
import ConfirmResetPopup from "../ui/ConfirmResetPopup";
import ARIA from "../utils/ARIA";

export default class SplashScene extends ResizableScene {
	private _onResize: () => void;
	container: Phaser.GameObjects.Container;
	playButton: Button;
	resetButton: Button;
	private soundButton: Button;
	private isSoundOn: boolean;

	create(): void {
		super.create();
		this.isSoundOn = !this.soundManager.muted;

		this.music.play("gameMusic");

		const background = this.add.image(0, 0, "splashBG");

		const characters = this.add.image(0, 0, "splashCharacters");

		const bushes = this.add.image(0, 0, "splashBushes");
		bushes.setOrigin(0, 1);

		const logo = this.add.image(0, 0, "splashLogo");

		const playButton = this.add.button(0, 0, "playButton", 0, this.play, this, true);

		const resetButton = (this.resetButton = this.add.button(0, 0, "resetButton", 0, this.reset, this, true));

		if (PlayerData.Instance.saveData.firstTimeUser) {
			resetButton.setVisible(false);
		}

		const soundButton = (this.soundButton = this.add.button(
			0,
			0,
			this.isSoundOn ? "soundBtnOn" : "soundBtnOff",
			null,
			this.onSoundPressed,
			this,
			true
		));
		soundButton.setScale(0.65);

		this._onResize = (): void => {
			let characterAdjustment = 0;
			let logoAdjustment = 0;
			const screenRatio = this.viewport.width / this.viewport.height;
			const goalRatio = 16 / 9;
			const ratioDif = screenRatio - goalRatio;
			if (screenRatio > goalRatio) characterAdjustment = 500 * ratioDif;
			else {
				logoAdjustment = 500 * ratioDif;
				logo.scale = 1 + ratioDif;
			}
			ScaleManager.ScaleBackgroundFromZone(background, this.viewport);
			ScaleManager.MatchWidth(bushes, this.viewport.width);
			this.alignIn.Center(background, this.viewport);
			this.alignIn.BottomLeft(characters, this.viewport, -characterAdjustment);
			this.alignIn.BottomLeft(bushes, this.viewport);
			this.alignIn.TopRight(logo, characters, logo.width / 2 + logoAdjustment, 180);
			this.alignTo.BottomCenter(playButton, logo, logo.displayWidth / 3 + logoAdjustment);
			this.alignIn.LeftCenter(resetButton, playButton, 200, 50);
			this.alignIn.TopLeft(soundButton, this.viewport, -20, -10);
		};
		this.resize();

		// ARIA Accessibility
		soundButton.setARIA("Toggle Sound");
		ARIA.addTextWithObject(logo, "Flurry's Search and Rescue Training", undefined, true);
		if (resetButton.visible) resetButton.setARIA("Reset Progress");
		playButton.setARIA("Play");

		this.tweens.add({
			targets: characters,
			alpha: { from: 0, to: 1 },
			duration: 500,
			ease: Phaser.Math.Easing.Back.Out,
		});
		characters.alpha = 0;

		const screenRatio = this.viewport.width / this.viewport.height;
		const goalRatio = 16 / 9;
		const ratioDif = screenRatio - goalRatio;
		let logoScale = 1;
		if (screenRatio <= goalRatio) logoScale = 1 + ratioDif;
		this.tweens.add({
			targets: logo,
			scale: { from: 0, to: logoScale },
			duration: 800,
			ease: Phaser.Math.Easing.Back.Out,
		});

		this.tweens.add({
			targets: [playButton, resetButton],
			scale: { from: 0, to: 1 },
			duration: 800,
			ease: Phaser.Math.Easing.Back.Out,
		});
		logo.scale = 0;
		playButton.scale = 0;
		resetButton.scale = 0;
	}

	resize(): void {
		super.resize();
		if (this._onResize != null) this._onResize();
	}

	protected onSoundPressed(): void {
		//TODO: Mute sounds
		this.soundManager.muted = !this.soundManager.muted;
		this.sound.mute = this.soundManager.muted;
		this.music.muted = !this.music.muted;
		this.isSoundOn = !this.soundManager.muted;
		if (!this.isSoundOn) this.soundButton.setTexture("soundBtnOff");
		else this.soundButton.setTexture("soundBtnOn");
	}

	play(): void {
		this.scene.start("PreloaderScene", { destinationScene: "LevelSelectScene" });
		// this.scene.start("PreloaderScene", { destinationScene: "GameScene" });
		this.scene.stop(this.scene.key);
	}

	reset(): void {
		const popup = new ConfirmResetPopup(
			this,
			() => {
				this.resetButton.removeARIA();
				this.resetButton.setVisible(false);
			},
			this
		);
		this.add.existing(popup);
	}

	shutdown(): void {
		this._onResize = null;
		this.playButton = null;
		this.container = null;
		super.shutdown();
	}
}
